import React, { Component, useEffect } from "react";

import {
  CPopover,
  CDropdown,
  CDropdownToggle,
  CDropdownMenu,
  CDropdownItem
} from "@coreui/react";
import { createPortal } from "react-dom";

import Interface from "../../Interface";

import "./styles.css";

const Portal = ({ children }) => {
  const mount = document.getElementById("root");
  const el = document.createElement("div");

  useEffect(() => {
    mount.appendChild(el);
    return () => mount.removeChild(el);
  }, [el, mount]);

  return createPortal(children, el);
};

class ContentItem extends Component {
  constructor(props) {
    super(props);
    this.contentRef = React.createRef();
    this.state = {
      // activity: false,
      // modal: false,
      // show: true,
      iframe: false
    };
  }

  openIframe = () => {
    window.open(
      `/content/view/${this.props.content.id}?title=${this.props.content.name}`,
      "_blank"
    );
    // this.setState({ iframe: true });
  };

  getContainerColor = color => {
    let raw = "";
    switch (color) {
      case "primary":
        raw = "#02517D";
        break;
      case "secondary":
        raw = "#ced2d8";
        break;
      case "success":
        raw = "#2eb85c";
        break;
      case "info":
        raw = "#3399ff";
        break;
      case "warning":
        raw = "#f9b115";
        break;
      case "danger":
        raw = "#e55353";
        break;
      case "light":
        raw = "#ebedef";
        break;
      case "dark":
        raw = "#636f83";
        break;
      default:
        break;
    }

    return `${raw}22`;
  };

  takeContent = contentId => {
    this.props.takeContentSelected(this.contentRef, contentId);
  };

  render() {
    const { content } = this.props;

    return (
      <>
        {this.state.iframe && (
          <Interface
            show
            title={content.name}
            onClose={() => this.setState({ iframe: false })}
            aula={content.id}
            currentRoute={this.props.currentRoute}
          />
        )}
        <div
          className={`contentItemCard mt-3 bg-${
            content.image ? "white" : this.props.color
          }`}
          onClick={
            this.props.isOfflineRegister
              ? () => this.takeContent(content.id)
              : this.openIframe
          }
          ref={this.contentRef}
        >
          {content.image ? (
            <div style={{ width: "5rem", height: "5rem" }}>
              <img
                src={content.image}
                className="h-100 w-100"
                style={{ objectFit: "cover" }}
              />
            </div>
          ) : (
            <div className="position-relative contentImg">
              <i
                className={`contentIcon fa fa-${this.props.icon} text-white`}
              ></i>
            </div>
          )}
          <div className="contentItemFooter">
            <div
              className="contentTitle"
              title={content.name}
              style={{
                lineHeight: "1rem",
                maxHeight: "2rem"
              }}
            >
              <div>{content.name}</div>
            </div>
            <div
              className="helpdeskStatus"
              id={content.helpdesk_status === "ABERTO" ? "opened" : "closed"}
            >
              {content.helpdesk_status}
            </div>
            {!this.props.hidePopover && (
              <CPopover
                header="Informações"
                content={
                  <>
                    <div>
                      <strong>Nome: </strong>
                      {content.name}
                    </div>
                    <div>
                      <strong>Resumo: </strong>
                      {content.resume}
                    </div>
                    <div>
                      <strong>Componente curricular: </strong>
                      {content.discipline_name}
                    </div>
                    <div>
                      <strong>Habilidades BNCC: </strong>
                      {content.ability_description}
                    </div>
                    <div>
                      <strong>Eixo temático BNCC: </strong>
                      {content.module_description}
                    </div>
                    <div>
                      <strong>Autor: </strong>
                      {content.author}
                    </div>
                    <div>
                      <strong>Ano: </strong>
                      {content.year}
                    </div>
                  </>
                }
                placement="right"
              >
                <i className="fa fa-info-circle contentInfo"></i>
              </CPopover>
            )}
            {this.props.menu && (
              <CDropdown
                className="contentInfo position-absolute"
                onClick={e => e.stopPropagation()}
              >
                <CDropdownToggle
                  color="white"
                  className="card-header-action remove-caret"
                >
                  <i className="fa fa-ellipsis-v"></i>
                </CDropdownToggle>
                <Portal>
                  <CDropdownMenu placement="bottom-start">
                    {this.props.menu.map((item, index) => (
                      <CDropdownItem
                        onClick={e => {
                          e.preventDefault();
                          item.onClick();
                        }}
                        key={index}
                      >
                        {item.text}
                      </CDropdownItem>
                    ))}
                  </CDropdownMenu>
                </Portal>
              </CDropdown>
            )}
          </div>
        </div>
      </>
    );
  }
}

export default ContentItem;
